//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[[0,"AxisExtrapolation",1,0],[0,"CylinderFitting",1,0],[0,"DatumPlaneFitting",1,0],[0,"LimitsOfSize",1,0],[0,"ProfileDisposition",1,0],[0,"Rx",1,0],[0,"RxLower",1,0],[0,"RxUpper",1,0],[0,"Ry",1,0],[0,"RyLower",1,0],[0,"RyUpper",1,0],[0,"Rz",1,0],[0,"RzLower",1,0],[0,"RzUpper",1,0],[0,"SurfaceProfile",1,0],[0,"ToleranceName",1,0],[0,"Tx",1,0],[0,"TxLower",1,0],[0,"TxUpper",1,0],[0,"Ty",1,0],[0,"TyLower",1,0],[0,"TyUpper",1,0],[0,"Tz",1,0],[0,"TzLower",1,0],[0,"TzUpper",1,0]],[[[],"UseDefault",{},0,0],[["objects"],"AnalyzeSelected",{},1,0],[[],"AnalyzeAll",{},0,0]],[]];
SPLM.CAM.InspectionAnalyzeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InspectionAnalyzeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.InspectionAnalyzeBuilder.DofTypes = Object.freeze({
    "On" : "On", "Off" : "Off", "Tolerance" : "Tolerance", "Limits" : "Limits"});

export default SPLM;